import clay6_1024 from '../assets/images/textures/clay_material_6.png';
import clay6_512 from '../assets/images/textures/clay_material_6_512x512.png';
import clay1024 from '../assets/images/textures/clay_material_10.png';
import clay512 from '../assets/images/textures/clay_material_10_512x512.png';
import silver256 from '../assets/images/textures/silver_matcap_2_2_256x256.png';
import silver128 from '../assets/images/textures/silver_matcap_2_2_128x128.png';
import arrow256 from '../assets/images/textures/arrowForCirlce_2_256x256.png';
import arrowsCircle256 from '../assets/images/textures/arrowsCirlce_256x256.png';
import fbCircle128 from '../assets/images/textures/fb.png';
import vkCircle128 from '../assets/images/textures/vk.png';
import okCircle128 from '../assets/images/textures/ok.png';
import score128 from '../assets/images/textures/scoreArrow_128x128.png';
import banknote512 from '../assets/images/textures/banknote-512x512.png';
import banknote256 from '../assets/images/textures/banknote-256x256.png';
import THREE from "../js/view/three/utils/threeClassesAdapter";
import {
    COLOR_COMMENT_BLOCK_BG, COLOR_DEFAULT_BUTTON,
    COLOR_OPTION_BUTTON_DEFAULT,
    COLOR_QUESTION_BLOCK_BG,
    COLOR_QUESTION_HEADING_BG
} from "../js/constants/colors";
import {Euler, Vector3} from "three";
import {textWidthDp, textWidthMb, textWidthPt, UNIT} from "../js/constants/sizes";

export const materialsLib = {
    matcapClay: {
        type: 'matcap',
        texturesTargetParam: 'matcap',
        side: THREE.DoubleSide,
        textures: [
            {
                src: clay1024,
                ratio: 1
            },
            {
                src: clay512,
                ratio: 0.5
            }
        ]
    },
    matcapClayColored: {
        type: 'matcap',
        texturesTargetParam: 'matcap',
        side: THREE.DoubleSide,
        vertexColors: true,
        textures: [
            {
                src: clay1024,
                ratio: 1
            },
            {
                src: clay512,
                ratio: 0.5
            }
        ]
    },
    flagMatcapClay: {
        type: 'flagmatcap',
        texturesTargetParam: 'matcap',
        side: THREE.DoubleSide,
        textures: [
            {
                src: clay1024,
                ratio: 1
            },
            {
                src: clay512,
                ratio: 0.5
            }
        ]
    },
    matcapClay6: {
        type: 'matcap',
        texturesTargetParam: 'matcap',
        side: THREE.DoubleSide,
        textures: [
            {
                src: clay6_1024,
                ratio: 1
            },
            {
                src: clay6_512,
                ratio: 0.5
            }
        ]
    },
    silver: {
        type: 'matcap',
        texturesTargetParam: 'matcap',
        side: THREE.DoubleSide,
        textures: [
            {
                src: silver256,
                ratio: 1
            },
            {
                src: silver128,
                ratio: 0.5
            }
        ]
    },
    questionTitleBackBasic: {
        type: 'basic',
        side: THREE.DoubleSide,
        color: COLOR_QUESTION_HEADING_BG
    },
    questionBackBasic: {
        type: 'basic',
        side: THREE.DoubleSide,
        color: COLOR_QUESTION_BLOCK_BG
    },
    questionOptionBackBasic: {
        type: 'basic',
        side: THREE.DoubleSide,
        color: COLOR_OPTION_BUTTON_DEFAULT
    },
    commentBackBasic: {
        type: 'basic',
        side: THREE.DoubleSide,
        color: COLOR_COMMENT_BLOCK_BG
    },
    buttonBackBasic: {
        type: 'basic',
        side: THREE.FrontSide,
        color: COLOR_DEFAULT_BUTTON
    },
    arrowButtonArrowBasic: {
        type: 'basic',
        texturesTargetParam: 'map',
        side: THREE.DoubleSide,
        color: 0xffffff,
        // transparent: false,
        transparent: true,
        textures: [
            {
                src: arrow256,
                ratio: 1
            }
        ]
    },
    arrowButtonCircleBasic: {
        type: 'basic',
        texturesTargetParam: 'map',
        side: THREE.DoubleSide,
        color: 0xffffff,
        // transparent: false,
        transparent: true,
        textures: [
            {
                src: arrowsCircle256,
                ratio: 1
            }
        ]
    },
    shareButtonBasic: {
        fbShare: {
            type: 'basic',
            texturesTargetParam: 'map',
            side: THREE.DoubleSide,
            color: 0xffffff,
            transparent: true,
            textures: [
                {
                    src: fbCircle128,
                    ratio: 1
                }
            ]
        },
        vk: {
            type: 'basic',
            texturesTargetParam: 'map',
            side: THREE.DoubleSide,
            color: 0xffffff,
            transparent: true,
            textures: [
                {
                    src: vkCircle128,
                    ratio: 1
                }
            ]
        },
        ok: {
            type: 'basic',
            texturesTargetParam: 'map',
            side: THREE.DoubleSide,
            color: 0xffffff,
            transparent: true,
            textures: [
                {
                    src: okCircle128,
                    ratio: 1
                }
            ]
        }
    },
    scoreArrowBasic: {
        type: 'basic',
        texturesTargetParam: 'map',
        side: THREE.FrontSide,
        color: 0xffffff,
        transparent: true,
        textures: [
            {
                src: score128,
                ratio: 1
            }
        ]
    },
    basicBanknote: {
        type: 'basic',
        texturesTargetParam: 'map',
        side: THREE.DoubleSide,
        color: 0xffffff,
        textures: [
            {
                src: banknote512,
                ratio: 1
            },
            {
                src: banknote256,
                ratio: 0.5
            }
        ]
    }
};

export const geometryLib = {
    pig: {
        type: 'fbx',
        src: 'models/pig.fbx'
    },
    diagram: {
        type: 'fbx',
        src: 'models/diagram.fbx'
    },
    bank: {
        type: 'fbx',
        src: 'models/bank-2.fbx'
    },
    coin: {
        type: 'fbx',
        src: 'models/coin-2-2.fbx'
    },
    arrow: {
        type: 'fbx',
        src: 'models/arrow.fbx'
    },
    wallet: {
        type: 'fbx',
        src: 'models/SM_Wallet.fbx'
    }
};

export const objectsLib = {
    pig: {
        geometryName: 'pig',
        material: materialsLib.matcapClayColored
    },
    diagram: {
        geometryName: 'diagram',
        material: materialsLib.matcapClayColored
    },
    bank: {
        geometryName: 'bank',
        material: materialsLib.matcapClay
    },
    coin: {
        geometryName: 'coin',
        material: materialsLib.silver
    },
    arrow: {
        geometryName: 'arrow',
        material: materialsLib.matcapClay
    },
    wallet: {
        geometryName: 'wallet',
        material: materialsLib.matcapClay
    },
    banknote: {
        geometryConstructorName: 'banknoteRect',
        material: materialsLib.basicBanknote
    },
    flag: {
        constructorName: 'flag',
        materialSet: [
            materialsLib.flagMatcapClay,
            materialsLib.silver
        ]
    }
};

export const decorationSettings = {
    coins: {
        elements: [
            {
                objectKey: 'coin',
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 0.7, -UNIT.refSize * 0.16, 0),
                        angle: Math.PI * 0.15,
                        scale: 0.3,
                        rotation: new Euler(-Math.PI * 0.11, Math.PI * 0.3,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(-textWidthPt * 0.93 * 0.88, -UNIT.refSize * 0.46, 0),
                        angle: Math.PI * 0.11,
                        scale: 0.3,
                        rotation: new Euler(-Math.PI * 0.11, Math.PI * 0.3,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        point: new Vector3(-textWidthMb * 0.93 * 0.67, -UNIT.refSize * 0.56, 0),
                        angle: Math.PI * 0.15,
                        scale: 0.3,
                        rotation: new Euler(-Math.PI * 0.11, Math.PI * 0.3,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(-textWidthDp * 0.93, -UNIT.refSize * 0.26, 0),
                        angle: Math.PI * 0.15,
                        scale: 0.3,
                        rotation: new Euler(-Math.PI * 0.11, Math.PI * 0.3,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'coin',
                map: {
                    landscape: {
                        point: new Vector3(textWidthDp * 1.5, UNIT.refSize * 0.16, 0),
                        angle: Math.PI * 0.25,
                        scale: 0.3,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(textWidthPt * 2.85 * 0.52, UNIT.refSize * 0.76, 0),
                        angle: Math.PI * 0.3,
                        scale: 0.26,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        point: new Vector3(textWidthMb * 2.85 * 0.52, UNIT.refSize * 1.06, 0),
                        angle: Math.PI * 0.3,
                        scale: 0.3,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(textWidthDp * 2.85, UNIT.refSize * 0.16, 0),
                        angle: Math.PI * 0.25,
                        scale: 0.3,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            }
        ]
    },
    arrow: {
        elements: [
            {
                objectKey: 'coin',
                angleStartDiff: -Math.PI * 3.7,
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 1.17, UNIT.refSize * 0.03, 0),
                        angle: -Math.PI * 0.17,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.12, Math.PI * 0.25,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(-textWidthPt * 1.27, UNIT.refSize * 0.03, 0),
                        angle: -Math.PI * 0.17,
                        scale: 0.34,
                        rotation: new Euler(-Math.PI * 0.12, Math.PI * 0.25,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(-textWidthDp * 1.77, UNIT.refSize * 0.03, 0),
                        angle: -Math.PI * 0.17,
                        scale: 0.34,
                        rotation: new Euler(-Math.PI * 0.12, Math.PI * 0.25,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'coin',
                angleStartDiff: -Math.PI * 4.5,
                map: {
                    landscape: {
                        point: new Vector3(textWidthDp * 1.85, UNIT.refSize * 0.35, 0),
                        angle: Math.PI * 0.31,
                        scale: 0.32,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(textWidthPt * 3.45, UNIT.refSize * 0.65, 0),
                        angle: Math.PI * 0.35,
                        scale: 0.34,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(textWidthDp * 4.45, UNIT.refSize * 0.35, 0),
                        angle: Math.PI * 0.29,
                        scale: 0.34,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'arrow',
                lookAhead: false,
                needLoop: false,
                angleStartDiff: -Math.PI * 3,
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 0.8, -UNIT.refSize * 0.23, 0),
                        angle: Math.PI * 0.17,
                        scale: 1,
                        rotation: new Euler(0, -Math.PI * 0.45,-Math.PI * 0.5, 'ZYX'),
                        // rotation: new Euler(-Math.PI * 0.35,0, Math.PI * 0.25, 'ZXY'),
                        rotationY: -Math.PI * 0.17
                    },
                    portrait: {
                        point: new Vector3(-textWidthPt * 1.05, -UNIT.refSize * 0.32, 0),
                        angle: Math.PI * 0.14,
                        scale: 1,
                        rotation: new Euler(0, -Math.PI * 0.45,-Math.PI * 0.5, 'ZYX'),
                        // rotation: new Euler(-Math.PI * 0.35,0, Math.PI * 0.25, 'ZXY'),
                        rotationY: -Math.PI * 0.17
                    },
                    mobileportrait: {
                        point: new Vector3(-textWidthMb * 1.05, -UNIT.refSize * 0.36, 0),
                        angle: Math.PI * 0.32,
                        scale: 1,
                        rotation: new Euler(0, -Math.PI * 0.45,-Math.PI * 0.5, 'ZYX'),
                        // rotation: new Euler(-Math.PI * 0.35,0, Math.PI * 0.25, 'ZXY'),
                        rotationY: -Math.PI * 0.32
                    },
                    mobilelandscape: {
                        point: new Vector3(-textWidthDp * 1.05, -UNIT.refSize * 0.2, 0),
                        angle: Math.PI * 0.17,
                        scale: 1,
                        rotation: new Euler(0, -Math.PI * 0.45,-Math.PI * 0.5, 'ZYX'),
                        // rotation: new Euler(-Math.PI * 0.35,0, Math.PI * 0.25, 'ZXY'),
                        rotationY: -Math.PI * 0.17
                    }
                }
            }
        ]
    },
    wallet: {
        elements: [
            {
                objectKey: 'coin',
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 1.12, -UNIT.refSize * 0.4, 0),
                        angle: -Math.PI * 0.17,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.16, Math.PI * 0.32,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(-textWidthMb * 1.12, UNIT.refSize * 0.4, 0),
                        angle: -Math.PI * 0.17,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.16, Math.PI * 0.32,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        take: 'portrait'
                    }
                }
            },
            {
                objectKey: 'coin',
                map: {
                    landscape: {
                        point: new Vector3(textWidthDp * 1.95, UNIT.refSize * 0.25, 0),
                        angle: Math.PI * 0.29,
                        scale: 0.32,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(textWidthMb * 0.95, -UNIT.refSize * 0.75, 0),
                        angle: Math.PI * 0.24,
                        scale: 0.38,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        take: 'portrait'
                    },
                    mobilelandscape: {
                        point: new Vector3(textWidthDp * 2.95, UNIT.refSize * 0.25, 0),
                        angle: Math.PI * 0.24,
                        scale: 0.38,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'wallet',
                loopFactor: 0.25,
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 0.96, -UNIT.refSize * 0.02, 0),
                        angle: Math.PI * 0.28,
                        scale: 0.07,
                        rotation: new Euler(Math.PI * 0.12, -Math.PI * 0.5,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(-textWidthMb * 0.86, -UNIT.refSize * 0.37, 0),
                        angle: Math.PI * 0.28,
                        scale: 0.09,
                        rotation: new Euler(Math.PI * 0.1, -Math.PI * 0.5,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        take: 'portrait'
                    },
                    mobilelandscape: {
                        point: new Vector3(-textWidthDp * 1.16, -UNIT.refSize * 0.17, 0),
                        angle: Math.PI * 0.28,
                        scale: 0.075,
                        rotation: new Euler(Math.PI * 0.12, -Math.PI * 0.5,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'banknote',
                loopFactor: 0.5,
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 0.87, 0, 0),
                        angle: Math.PI * 0.26,
                        scale: 1,
                        rotation: new Euler(0, 0,-Math.PI * 0.68, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(-textWidthMb * 0.73, -UNIT.refSize * 0.35, 0),
                        angle: Math.PI * 0.26,
                        scale: 1.3,
                        rotation: new Euler(0, 0,-Math.PI * 0.68, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        take: 'portrait'
                    },
                    mobilelandscape: {
                        point: new Vector3(-textWidthDp * 1.07, -UNIT.refSize * 0.14, 0),
                        angle: Math.PI * 0.26,
                        scale: 1,
                        rotation: new Euler(0, 0,-Math.PI * 0.68, 'YXZ'),
                        rotationY: 0
                    }
                }
            }
        ]
    },
    flag: {
        elements: [
            {
                objectKey: 'coin',
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 1.22, -UNIT.refSize * 0.24, 0),
                        angle: -Math.PI * 0.17,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.16, Math.PI * 0.32,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(-textWidthPt * 1.08, UNIT.refSize * 0.04, 0),
                        angle: -Math.PI * 0.07,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.16, Math.PI * 0.32,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        point: new Vector3(-textWidthPt * 1.08, UNIT.refSize * 0.54, 0),
                        angle: -Math.PI * 0.07,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.16, Math.PI * 0.32,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(-textWidthDp * 1.78, UNIT.refSize * 0.04, 0),
                        angle: -Math.PI * 0.17,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.16, Math.PI * 0.32,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'coin',
                map: {
                    landscape: {
                        point: new Vector3(textWidthDp * 1.85, UNIT.refSize * 0.35, 0),
                        angle: Math.PI * 0.29,
                        scale: 0.32,
                        rotation: new Euler(-Math.PI * 0.02, Math.PI * 0.16,0, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(textWidthPt * 1.75, UNIT.refSize * 0.85, 0),
                        angle: Math.PI * 0.32,
                        scale: 0.29,
                        rotation: new Euler(-Math.PI * 0.02, Math.PI * 0.16,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        point: new Vector3(textWidthPt * 1.75, UNIT.refSize * 1.05, 0),
                        angle: Math.PI * 0.32,
                        scale: 0.29,
                        rotation: new Euler(-Math.PI * 0.02, Math.PI * 0.16,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(textWidthDp * 2.45, UNIT.refSize * 0.45, 0),
                        angle: Math.PI * 0.24,
                        scale: 0.29,
                        rotation: new Euler(-Math.PI * 0.02, Math.PI * 0.16,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'coin',
                angleStartDiff: Math.PI * 4.1,
                map: {
                    landscape: {
                        point: new Vector3(textWidthDp * 4.15, -UNIT.refSize * 0.75, 0),
                        angle: Math.PI * 0.33,
                        scale: 0.32,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(textWidthDp * 4.15, -UNIT.refSize * 0.85, 0),
                        angle: Math.PI * 0.33,
                        scale: 0.32,
                        rotation: new Euler(Math.PI * 0.11, Math.PI * 0.1,0, 'YXZ'),
                        rotationY: 0
                    }
                }
            },
            {
                objectKey: 'flag',
                hasInvalidate: true,
                needLoop: false,
                map: {
                    landscape: {
                        point: new Vector3(-textWidthDp * 0.95, UNIT.refSize * 0.05, 0),
                        angle: Math.PI * 0.26,
                        scale: 0.9,
                        rotation: new Euler(0, 0,-Math.PI * 0.18, 'YXZ'),
                        rotationY: 0
                    },
                    portrait: {
                        point: new Vector3(-textWidthMb * 0.87, -UNIT.refSize * 0.35, 0),
                        angle: Math.PI * 0.26,
                        scale: 1,
                        rotation: new Euler(0, 0,-Math.PI * 0.18, 'YXZ'),
                        rotationY: 0
                    },
                    mobileportrait: {
                        point: new Vector3(-textWidthMb * 0.83, -UNIT.refSize * 0.4, 0),
                        angle: Math.PI * 0.26,
                        scale: 1.1,
                        rotation: new Euler(0, 0,-Math.PI * 0.18, 'YXZ'),
                        rotationY: 0
                    },
                    mobilelandscape: {
                        point: new Vector3(-textWidthDp * 1.12, -UNIT.refSize * 0.21, 0),
                        angle: Math.PI * 0.26,
                        scale: 1,
                        rotation: new Euler(0, 0,-Math.PI * 0.18, 'YXZ'),
                        rotationY: 0
                    }
                }
            }
        ]
    }
};
